import { render, staticRenderFns } from "./PrintClubsTable.vue?vue&type=template&id=215a6a6a&"
import script from "./PrintClubsTable.vue?vue&type=script&lang=js&"
export * from "./PrintClubsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports